var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"guidebox"},[_c('div',{staticClass:"guidetext"},[_vm._v("打开猫咪APP 播放更流畅 评论更精彩")]),_vm._v(" "),_c('div',{staticClass:"guidenbutton",on:{"click":_vm.addopen}},[_vm._v("立即打开")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8a14f5f0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/common/guide.vue
// module id = null
// module chunks = 